import { action, makeObservable, observable } from "mobx";
import UserReportsApi, {
  UserReportsApi as IUserReportsApi
} from "../../../../services/api/v2/userReports/UserReports.api";
import { NavigateFunction } from "react-router-dom";
import { EntityTypes, GridTypes } from "../../../../enums";
import { ActionsDashboardGridModel } from "./grid/ActionsDashboardGrid_model";
import { MapActionsToProgressPie, MapActionsToRagPie } from "./Actions_mapper";

export class ActionsModel {
  @observable isLoading: boolean = true;
  @observable.ref gridActions = [];
  organisationId: number;
  userReportProvider: IUserReportsApi;
  gridModel: ActionsDashboardGridModel;
  pieData: any;
  progressData: any[];

  constructor(
    organisationId: number,
    projectId: number,
    authUser: FP.Entities.IUser,
    columnDefs: FP.Entities.IColumnDef[],
    urlSearchParams: URLSearchParams,
    preSelectedItemIds: number[],
    gridType: EntityTypes | GridTypes,
    navigate: NavigateFunction,
    onFieldUpdate: () => Promise<void>
  ) {
    makeObservable(this);
    this.organisationId = organisationId;

    this.gridModel = new ActionsDashboardGridModel(
      organisationId,
      projectId,
      authUser,
      columnDefs,
      urlSearchParams,
      preSelectedItemIds,
      gridType,
      navigate,
      this.handleFieldUpdate
    );
    this.userReportProvider = UserReportsApi;
  }

  onMount = async () => {
    await this.gridModel.onMount();
    await this.loadActions();
  };

  onUnmount = () => {};

  onGridReady = (params: any) => {
    this.gridModel.setGridApi(params);
  };

  loadActions = async () => {
    let res = await this.userReportProvider.getUserActions(this.organisationId);
    if (!res) return;
    this.setActions(res.payload);
  };

  @action
  setActions = (actions: any[]) => {
    this.pieData = MapActionsToRagPie(actions);
    this.progressData = MapActionsToProgressPie(actions);
    this.gridActions = actions;
    this.isLoading = false;
  };

  @action
  handleFieldUpdate = async () => {
    await this.loadActions();
  };
}
